import { jsx as i } from "../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import l from "classnames";
import { ButtonVariant as n } from "../Button/types.js";
import { useState as s, useEffect as c } from "../../../external/preact/hooks/dist/hooks.module.js";
import m from "../../../core/Context/useCoreContext.js";
import { useResponsiveViewport as u, mediaQueries as f } from "../../../hooks/useResponsiveViewport.js";
/* empty css               */
import a from "../Button/Button.js";
import { Icon as d } from "../Icon/Icon.js";
import { isFunction as b } from "../../../utils/value/is.js";
const o = "adyen-pe-filter-bar-mobile-switch", E = () => {
  const e = u(f.down.xs), [t, r] = s(!e);
  return c(() => {
    r(!e);
  }, [e]), { isMobileViewport: e, showingFilters: t, setShowingFilters: r };
}, F = ({ isMobileViewport: e, showingFilters: t, setShowingFilters: r }) => e ? /* @__PURE__ */ i("div", { className: o, children: /* @__PURE__ */ i(
  a,
  {
    iconButton: !0,
    className: `${o}__button`,
    disabled: !b(r),
    onClick: () => r == null ? void 0 : r(!t),
    variant: n.SECONDARY,
    children: /* @__PURE__ */ i(d, { name: t ? "cross" : "filter" })
  }
) }) : null, I = (e) => {
  const { i18n: t } = m();
  return e.showingFilters ? /* @__PURE__ */ i(
    "div",
    {
      "aria-label": t.get("filterBar"),
      className: l("adyen-pe-filter-bar", { "adyen-pe-filter-bar__content--mobile": e.isMobileViewport }),
      children: [
        e.children,
        e.canResetFilters && !!e.resetFilters && /* @__PURE__ */ i(a, { variant: n.TERTIARY, onClick: e.resetFilters, children: t.get("button.clearAll") })
      ]
    }
  ) : null;
};
export {
  I as FilterBar,
  F as FilterBarMobileSwitch,
  I as default,
  E as useFilterBarState
};
